import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { toast } from "../../components/ui/use-toast";
import { API, fileUpload } from "../../config";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";

const AddCard = ({
  showAddCard,
  setShowAddCard,
  toggleAddCard,
  fetchCardDetails,
  cards,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [defaultCard, setDefaultCard] = useState(false);
  const [cardComplete, setCardComplete] = useState(false);

  const { organizationData } = useOrganization();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      toast({
        variant: "destructive",
        description: "Stripe Elements not loaded.",
      });
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      toast({
        variant: "destructive",
        description: "Card details are missing.",
      });
      setLoading(false);
      return;
    }

    try {
      const { paymentMethod, error: pmError } =
        await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        });

      if (pmError) throw new Error(pmError.message || "Payment method failed");

      const formData = new FormData();
      formData.append(
        "organization_id",
        organizationData?.organizationId || ""
      );
      formData.append("payment_method_id", paymentMethod?.id || "");
      formData.append("default", defaultCard);
      formData.append("type", 1);
      formData.append("_method", "put");

      const { data } = await fileUpload(API.GET_PAYMENT_METHODS, formData);
      if (data) {
        fetchCardDetails();
        toggleAddCard();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Add Card"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[500px]"}
      open={showAddCard}
      buttonClassName={""}
      setOpen={setShowAddCard}
      read={true}
      mobileCancelHidden={true}
    >
      <div className="md:p-0 p-2">
        {loading && <Spin expand={true} fullscreen={true}/>}

        <form onSubmit={handleSubmit}>
          <CardElement
            className="pl-3 pr-1 py-2 border border-gray-300 rounded-md bg-white"
            options={{ hidePostalCode: true }}
            onChange={(event) => {
              setCardComplete(event.complete);
            }}
          />
          <div className="flex items-center space-x-2 mt-4">
            <Checkbox
              id="terms"
              checked={defaultCard}
              value={defaultCard}
              name="same_address"
              onClick={() => setDefaultCard(!defaultCard)}
            />
            <label
              htmlFor="terms"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              onClick={() => {
                setDefaultCard(!defaultCard);
              }}
            >
              Make Default
            </label>
          </div>
          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button type="submit" disabled={loading && !cardComplete}>
              Save
            </Button>
            <Button
              className="reset ml-3"
              variant="secondary"
              onClick={() => toggleAddCard()}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </ResponsiveDrawerForm>
  );
};

export default AddCard;
